import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private excludedUrls: string[] = [
    '/getCustomerUsages',
    "/Subscriptions",
    "/GetlineInfoMore",
    "/get-ticket-statuses",
    "/getMinimalProfileData",
    "/GetPrePaidPlans",
    "/getActivityInfo",
    "/getCustomerPersonalInfo",
    "/getPlanScheduler",
    "/getCustomerInfo",
    "/getEligibilityInfo",
    "/changeCustomerInfo",
    "/usageDetails",
    "/get-note",
    "/getZipCodeId"


  ];

  constructor(private loaderService: LoaderService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isExcluded = this.excludedUrls.some(url => req.url.includes(url));
    const hideLoader = req.headers.get('X-Hide-Loader') === 'true';
    const shouldShowLoader = !hideLoader && !this.loaderService.expiredTokenModalOpen && !isExcluded;
  
    // ✅ Only show loader once
    if (shouldShowLoader) {
      this.loaderService.showLoader();
    }
  
    return next.handle(req).pipe(
      finalize(() => {
        if (shouldShowLoader) {
          this.loaderService.hideLoader();
        }
      })
    );
  }
  
}
